import { useContext, useEffect, useState } from 'react';

import { INSIGHTS } from 'constants/locations';
import { PRE_SIGNAL_QUERY, TAGS_QUERY } from 'constants/queryParams';
import { FilterState } from 'contexts/filtersContext';
import { useTranslationsContext } from 'contexts/translationsContext';
import { UserContext } from 'contexts/userContext';
import { getSignalsMessages } from 'data/getSignalsMessages';
import { getTags } from 'data/getTags';
import { getUserEventFollow } from 'data/getUserEventFollow';
import { setBookmarkedSignals } from 'data/setBookmarkedSignals';
import { setLikedSignals } from 'data/setLikedSignals';
import { setTerms } from 'data/setTerms';
import { setUserEventFollow } from 'data/setUserEventFollow';
import * as fxsSignalsInsights from 'fxs-signals-insights';
import { EditorialMessage, SignalsMessageState } from 'models/signalMessages';
import { getQueryParam } from 'utils/getQueryParam';
import { mapNonFXTags } from 'utils/mapTags';

import { FXSInsightsWrapper } from './styles';

const initialState: SignalsMessageState = {
	messages: undefined,
	isFetching: true
};

const PreSignalLatest = () => {
	const { user } = useContext(UserContext);
	const { t } = useTranslationsContext();
	const culture = window.config.Variables.Culture;
	const [preSignalData, setPreSignalData] = useState(initialState);

	const preOrderTitle = getQueryParam(PRE_SIGNAL_QUERY);
	const tags = mapNonFXTags(getQueryParam(TAGS_QUERY));

	const filter: FilterState = {
		categories: [],
		markets: [],
		tags: []
	};

	useEffect(() => {
		getTags(user).then((allTags) => {
			allTags['Tags'].forEach((x) => {
				if (tags.includes(x.Name.toLowerCase())) {
					filter.tags.push(x.Id);
				}
			});
			getSignalsMessages(user, undefined, filter).then((payload) => {
				const messages = payload.data.map(
					(message) => message as EditorialMessage
				);
				setPreSignalData({
					messages: messages.filter((data) =>
						data.title
							?.toLocaleLowerCase()
							.includes(preOrderTitle.toLocaleLowerCase())
					),
					isFetching: false
				});
			});
		});
	}, []);

	return (
		<FXSInsightsWrapper>
			<fxsSignalsInsights.SignalsInsights
				isPremium={user?.isPremium}
				data={preSignalData.messages}
				isFetching={preSignalData.isFetching}
				t={t}
				culture={culture}
				signalsPageUrl={window.config.Variables.SignalsLandingUrl}
				setLike={(id, status) => setLikedSignals(user, id, status)}
				setBookmark={(id, status) => setBookmarkedSignals(user, id, status)}
				getEventFollow={(eventId) => getUserEventFollow(user, eventId)}
				setEventFollow={(eventId, eventTitle) =>
					setUserEventFollow(user, eventId, eventTitle)
				}
				setTerms={(eventTitle) => setTerms(user, eventTitle)}
				messagePageUrl={`/${INSIGHTS}/`}
				isEmployee={user?.isEmployee}
			/>
		</FXSInsightsWrapper>
	);
};

export default PreSignalLatest;
